module.exports = __webpack_public_path__ + "fde6b7e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/right-arrow-line.svg
// module id = 1935
// module chunks = 15 17 21 32 36